import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconGroup: React.FC<IconProps> = ({ ...props }) => {
  return (
    <Icon {...props}>
      <rect width="24" height="24" rx="4" fill="#F7F7F8" />
      <path
        d="M12 7V12M12 12H17M12 12H7M12 12V17"
        stroke="#262F56"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

export default IconGroup;
